// src/api/permissionsApi.js
// API สำหรับดึง view permissions ของ client

import { createAuthenticatedClient, handleResponse, handleError } from './axiosConfig';

/**
 * ดึง view permissions ของ user ปัจจุบัน
 * GET /api/view-permissions
 * @returns {Promise<{success: boolean, data: {flowaccount: boolean, peakaccount: boolean, thaibulksms: boolean, smartcomm: boolean}}>}
 */
export const fetchViewPermissions = async () => {
    try {
        const client = createAuthenticatedClient();
        const response = await client.get('/api/view-permissions');
        return handleResponse(response);
    } catch (error) {
        return handleError(error);
    }
};

export default {
    fetchViewPermissions,
};
